import { BaseApi } from '@/main/baseApi';

import { NAME, DMS_MODULE } from './constants';

class SplitBillingProvider extends BaseApi {
	async updateList(data: Record<string, any>, serviceOrderId: number | null, serviceJobId: number | null, partLineItemDiscountPercentLimit: number | null = null, laborLineItemDiscountPercentLimit: number |null= null) {
		let url = `${this.apiPath}SaveServiceJobSplitParty?serviceOrderId=${serviceOrderId}&serviceJobId=${serviceJobId}`;
		if (partLineItemDiscountPercentLimit !== null) {
			url += `&partLineItemDiscountPercentLimit=${partLineItemDiscountPercentLimit}`;
		}
		if (laborLineItemDiscountPercentLimit !== null) {
			url += `&laborLineItemDiscountPercentLimit=${laborLineItemDiscountPercentLimit}`;
		}
		return this.post(url, data);
	}

	async fetchCustomerType(customerId: number |null){
		return this.fetch(`${this.apiPath}FetchCustomerTypeByCustomerId?customerId=${customerId}`)
	}

	async fetchSplitPartyNames(serviceOrderId: number | null){
		return this.fetch(`${this.apiPath}GetSplitPartyNames?serviceOrderId=${serviceOrderId}`)
	}
	async getPartyInvoicedDetails(serviceOrderId: number | null) {
		return this.fetch(`${this.apiPath}GetPartyInvoicedDetails?serviceOrderId=${serviceOrderId}`);
	}

	async getSplitPartyForOrder(orderId: number) {
		return this.fetch(`/${DMS_MODULE}/SplitBilling/GetSplitPartyForOrder?orderId=${orderId}`);
	}

	async canAddSagaSplits(serviceJobId: number | null, serviceOrderId: number | null) {
		return this.fetch(`${this.apiPath}CanAddSagaSplitsInServiceJob`, { serviceJobId, serviceOrderId });
	}
}

export const apiProvider = new SplitBillingProvider(DMS_MODULE, NAME);
